import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbStatic = [{
	name: "Dispatcher's Daily Activities",
	url: '/managers/time_tracking/daily_activities',
	icon: 'dashboard'
}];

export default class DispatcherDailyActivities extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.DispatcherDailyActivities history={history} />
					</div>
				</div>
			</div>
		)
	}
}
